<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@/api/models/auth/ability";
import { canOpenBillingPage, readBillingRights } from "@/composables/shared/billingAccess";
import MsoInvoicesSection from "@/components/models/practice/detail/MsoInvoicesSection.vue";
import BillingSection from "@/components/models/practice/detail/BillingSection.vue";
import BillingShell from "@/components/models/billing/BillingShell.vue";

definePage({
  meta: {
    title: "generic.fields.sections.invoices",
    checkPrivileges: () => {
      const { can } = useAbility();
      return canOpenBillingPage(readBillingRights(can), "invoices");
    },
  },
});
</script>

<template>
  <billing-shell page="invoices">
    <template #default="{ scope: ownerScope, mso, company }">
      <mso-invoices-section
        v-if="ownerScope === 'mso' && mso"
        :key="`mso-${mso.id}`"
        :mso-id="mso.id"
      />

      <billing-section
        v-else-if="ownerScope === 'company' && company"
        :key="`company-${company.id}`"
        :company-id="company.id"
        tab="invoices"
      />
    </template>
  </billing-shell>
</template>
